/* dtable-dividers-v3-desktop · no-default-title-2026-08-13 */
/* unit-price-js-fallback-v2 · product.js hydrate for PAngV */
/**
 * Lynden PDP v2 harness — gallery, multi-option variants, ATC
 * Works for any product (not brand-specific).
 */
(function () {
  function qs(s, r) {
    return (r || document).querySelector(s);
  }
  function qsa(s, r) {
    return Array.prototype.slice.call((r || document).querySelectorAll(s));
  }

  function money(cents, root) {
    var amount = (Number(cents) / 100).toFixed(2).replace(".", ",");
    var fmt = (root && root.getAttribute("data-money-format")) || "{{amount}} €";
    if (fmt.indexOf("{{amount") === -1) return amount + " €";
    return fmt
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, amount)
      .replace(/\{\{\s*amount\s*\}\}/g, amount);
  }

  function parseVariants(root) {
    var el = qs("[data-hv2-variants-json]", root);
    if (!el) return [];
    try {
      return JSON.parse(el.textContent || "[]");
    } catch (e) {
      return [];
    }
  }

  /**
   * Shop-wide nicotine unit style: "10mg" never "10 mg/ml" / "10mg/ml".
   * Walks text nodes so body copy, specs, FAQ, chips all match.
   */
  function normalizeMgMlInString(s) {
    if (!s || s.indexOf("mg") === -1) return s;
    return String(s).replace(
      /(\d+(?:[.,]\d+)?)\s*[-–—]?\s*mg\s*\/\s*ml/gi,
      function (_m, n) {
        var raw = String(n).replace(",", ".");
        var num =
          raw.indexOf(".") >= 0
            ? String(parseFloat(raw))
            : String(parseInt(raw, 10));
        return num + "mg";
      }
    );
  }

  function normalizeMgMlInTree(root) {
    if (!root || root.nodeType !== 1) return;
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
    var nodes = [];
    var node;
    while ((node = walker.nextNode())) {
      nodes.push(node);
    }
    nodes.forEach(function (n) {
      // skip JSON blobs / scripts (variant match must keep original option strings)
      var p = n.parentNode;
      if (!p) return;
      var tag = p.tagName;
      if (tag === "SCRIPT" || tag === "STYLE" || tag === "NOSCRIPT") return;
      if (p.closest && p.closest("[data-hv2-variants-json]")) return;
      var t = n.nodeValue;
      if (!t || t.indexOf("mg") === -1) return;
      var next = normalizeMgMlInString(t);
      if (next !== t) n.nodeValue = next;
    });
  }

  function init(root) {
    if (!root || root.dataset.lydHv2Init === "1") return;
    root.dataset.lydHv2Init = "1";

    var form = qs("[data-hv2-form]", root);
    var idInput = form && qs('input[name="id"]', form);
    var priceEl = qs("[data-hv2-price]", root);
    var compareEl = qs("[data-hv2-compare]", root);
    var badgeEl = qs("[data-hv2-badge]", root);
    var unitPriceEl = qs("[data-hv2-unitprice]", root);
    var atc = qs("[data-hv2-atc]", root);
    var stageImg = qs("[data-hv2-stage-img]", root);
    var qtyInput = qs("[data-hv2-qty]", root);
    var variants = parseVariants(root);
    var optionRows = qsa("[data-hv2-option]", root);
    var thumbs = qsa("[data-hv2-thumb]", root);
    var shipEl = qs("[data-hv2-ship]", root);
    var shipText = shipEl && qs("[data-hv2-ship-text]", shipEl);

    var selected = [];
    optionRows.forEach(function (row, i) {
      var on = qs("[data-hv2-opt].is-selected", row);
      selected[i] = on
        ? on.getAttribute("data-value")
        : (qs("[data-hv2-opt]", row) || {}).getAttribute
        ? qs("[data-hv2-opt]", row).getAttribute("data-value")
        : "";
    });

    function findVariant() {
      return (
        variants.find(function (v) {
          return selected.every(function (val, i) {
            if (val == null || val === "") return true;
            return String(v.options[i] || "") === String(val);
          });
        }) || null
      );
    }

    /**
     * Is optionIndex=value orderable given the other currently selected options?
     * Single-option PDPs: true iff that variant is available.
     */
    function isOptionValueAvailable(optionIndex, value) {
      return variants.some(function (v) {
        if (String(v.options[optionIndex] || "") !== String(value)) return false;
        if (!v.available) return false;
        return selected.every(function (sel, j) {
          if (j === optionIndex) return true;
          if (sel == null || sel === "") return true;
          return String(v.options[j] || "") === String(sel);
        });
      });
    }

    /** Mark chips sold-out at a glance (still clickable). */
    function updateUnavailableChips() {
      optionRows.forEach(function (row, i) {
        qsa("[data-hv2-opt]", row).forEach(function (btn) {
          var val = btn.getAttribute("data-value");
          var ok = isOptionValueAvailable(i, val);
          btn.classList.toggle("is-unavailable", !ok);
          if (ok) {
            btn.removeAttribute("aria-description");
            btn.removeAttribute("title");
          } else {
            btn.setAttribute("aria-description", "Ausverkauft");
            btn.setAttribute("title", "Derzeit ausverkauft");
          }
          var oos = qs(".lyd-hv2__chip-oos", btn);
          if (!ok && !oos) {
            oos = document.createElement("span");
            oos.className = "lyd-hv2__chip-oos";
            oos.setAttribute("aria-hidden", "true");
            oos.textContent = "Ausverkauft";
            btn.appendChild(oos);
          } else if (ok && oos) {
            oos.parentNode.removeChild(oos);
          }
        });
      });
    }

    function isVariantPreorder(variant) {
      if (!variant || !variant.available) return false;
      if (variant.preorder === true) return true;
      var qty = Number(variant.inventory_quantity);
      var policy = String(variant.inventory_policy || "").toLowerCase();
      return !isNaN(qty) && qty <= 0 && policy === "continue";
    }

    function updateShipNote(available, variant) {
      if (!shipEl) return false;
      var inTxt = shipEl.getAttribute("data-ship-in") || "";
      var preTxt =
        shipEl.getAttribute("data-ship-preorder-text") ||
        "Vorbestellung · Versand in KW 35 (ab 24. August 2026)";
      var oosTxt = shipEl.getAttribute("data-ship-oos") || "Ausverkauft";
      var isPre = !!(available && isVariantPreorder(variant));
      shipEl.classList.toggle("is-oos", !available);
      shipEl.classList.toggle("is-preorder", !!isPre);
      if (shipText) {
        if (!available) shipText.textContent = oosTxt;
        else if (isPre) shipText.textContent = preTxt;
        else shipText.textContent = inTxt;
      }
      return isPre;
    }

    function applyVariant(v) {
      if (!v) {
        if (atc) {
          atc.disabled = true;
          atc.textContent = atc.getAttribute("data-label-soldout") || "Ausverkauft";
        }
        updateShipNote(false, null);
        updateUnavailableChips();
        return;
      }
      if (idInput) idInput.value = v.id;
      if (priceEl) priceEl.textContent = money(v.price, root);
      if (compareEl) {
        if (v.compare && Number(v.compare) > Number(v.price)) {
          compareEl.textContent = money(v.compare, root);
          compareEl.hidden = false;
        } else {
          compareEl.hidden = true;
        }
      }
      if (badgeEl) {
        if (v.compare && Number(v.compare) > Number(v.price)) {
          badgeEl.textContent =
            "−" + Math.round((1 - Number(v.price) / Number(v.compare)) * 100) + " %";
          badgeEl.hidden = false;
        } else {
          badgeEl.hidden = true;
        }
      }
      // Grundpreis PAngV — fill goods only (Liquid / Nikotinsalz / Prefilled / Depot).
      // Never invent unit price for hardware. If Shopify has unit_ml / product.js unit_price, show it.
      if (unitPriceEl) {
        var unitAllowed =
          root.getAttribute("data-hv2-unit-allowed") === "1" ||
          unitPriceEl.getAttribute("data-hv2-unit-allowed") === "1";
        // Allow when Liquid JSON already carries unit_ml (Shopify unit_price_measurement)
        if (!unitAllowed && v.unit_ml != null && Number(v.unit_ml) > 0) {
          unitAllowed = true;
        }
        // product.js hydrate (bypasses stale Liquid allowlist / page cache)
        if (!unitAllowed && v.sf_unit_ml != null && Number(v.sf_unit_ml) > 0) {
          unitAllowed = true;
        }
        var unitLabel = unitAllowed ? v.unit_price_label : null;
        if (unitAllowed && !unitLabel) {
          var ml =
            v.unit_ml != null && Number(v.unit_ml) > 0
              ? Number(v.unit_ml)
              : v.sf_unit_ml != null && Number(v.sf_unit_ml) > 0
                ? Number(v.sf_unit_ml)
                : parseFloat(unitPriceEl.getAttribute("data-hv2-unit-ml") || "0") || 0;
          var ptype = (root.getAttribute("data-product-type") || "").toLowerCase();
          if (
            !ml &&
            /liquid|nikotinsalz|depot|prefilled/.test(ptype)
          ) {
            ml = 10;
          }
          // Prefer Shopify cents unit_price when present
          var unitCents =
            v.sf_unit_price != null
              ? Number(v.sf_unit_price)
              : v.unit_price != null
                ? Number(v.unit_price)
                : null;
          if (ml > 0 && v.price != null) {
            var perLiter =
              unitCents != null && unitCents > 0
                ? unitCents
                : Math.round((Number(v.price) * 1000) / ml);
            var mlStr = String(ml).replace(".", ",");
            unitLabel =
              "Inhalt: " +
              mlStr +
              " ml (" +
              money(perLiter, root) +
              "* / 1 Liter)";
          }
        }
        if (unitLabel) {
          unitPriceEl.textContent = unitLabel;
          unitPriceEl.hidden = false;
          unitPriceEl.removeAttribute("hidden");
          root.setAttribute("data-hv2-unit-allowed", "1");
        } else {
          unitPriceEl.textContent = "";
          unitPriceEl.hidden = true;
          unitPriceEl.setAttribute("hidden", "hidden");
        }
      }
      var isPre = isVariantPreorder(v);
      if (atc) {
        atc.disabled = !v.available;
        if (!v.available) {
          atc.textContent = atc.getAttribute("data-label-soldout") || "Ausverkauft";
        } else {
          var label = isPre
            ? (atc.getAttribute("data-label-preorder") || "Vorbestellen")
            : (atc.getAttribute("data-label-add") || "In den Warenkorb");
          atc.textContent = label + " — " + money(v.price, root);
        }
      }
      updateShipNote(!!v.available, v);
      optionRows.forEach(function (row, i) {
        var lab = qs("[data-hv2-selected-label]", row);
        if (lab && v.options[i] != null) lab.textContent = v.options[i];
      });
      if (v.image && stageImg) {
        setStageImage(v.image, { fromVariant: true });
      }
      // mark options selected
      optionRows.forEach(function (row, i) {
        qsa("[data-hv2-opt]", row).forEach(function (btn) {
          btn.classList.toggle(
            "is-selected",
            btn.getAttribute("data-value") === String(selected[i] || "")
          );
        });
      });
      updateUnavailableChips();
    }

    /** Gallery helpers: centered stage + thumbnail sync + swipe */
    var galleryUrls = thumbs
      .map(function (t) {
        return t.getAttribute("data-full");
      })
      .filter(Boolean);
    var galleryIndex = 0;

    function normalizeUrl(u) {
      if (!u) return "";
      // compare path without size/crop query noise
      return String(u).split("?")[0].replace(/^https?:/, "");
    }

    function forceStageImgCss() {
      if (!stageImg) return;
      // Nuclear iOS fix: fill frame, contain, never absolute/transform
      stageImg.style.cssText = [
        "width:100%",
        "height:100%",
        "max-width:100%",
        "max-height:100%",
        "object-fit:contain",
        "object-position:center center",
        "display:block",
        "margin:0",
        "padding:0",
        "border:0",
        "position:static",
        "transform:none",
        "opacity:1",
        "visibility:visible",
      ].join(";");
      stageImg.setAttribute("draggable", "false");
    }

    function setStageImage(src, opts) {
      if (!stageImg || !src) return;
      stageImg.src = src;
      forceStageImgCss();
      // sync active thumb
      var ni = normalizeUrl(src);
      var file = ni.split("/").pop() || "";
      var matched = -1;
      thumbs.forEach(function (t, i) {
        var full = t.getAttribute("data-full") || "";
        var nf = normalizeUrl(full);
        var on =
          nf === ni ||
          full === src ||
          (file && nf.indexOf(file) !== -1) ||
          (file && full.indexOf(file) !== -1);
        t.classList.toggle("is-active", on);
        if (on && matched < 0) matched = i;
      });
      if (matched >= 0) {
        galleryIndex = matched;
        scrollThumbsTo(matched, opts && opts.instant);
      }
    }

    function scrollThumbsTo(index, instant) {
      var strip = qs("[data-hv2-thumbs]", root);
      var thumb = thumbs[index];
      if (!strip || !thumb) return;
      // Use scrollLeft math only (scrollIntoView jumps the page on iOS)
      var target =
        thumb.offsetLeft - (strip.clientWidth - thumb.clientWidth) / 2;
      if (typeof strip.scrollTo === "function") {
        strip.scrollTo({
          left: Math.max(0, target),
          behavior: instant ? "auto" : "smooth",
        });
      } else {
        strip.scrollLeft = Math.max(0, target);
      }
    }

    function showGalleryIndex(i) {
      if (!galleryUrls.length) return;
      var n = galleryUrls.length;
      galleryIndex = ((i % n) + n) % n;
      setStageImage(galleryUrls[galleryIndex]);
    }

    function wireGallerySwipe() {
      var stage = qs("[data-hv2-stage]", root) || qs(".lyd-hv2__stage", root);
      if (!stage || !stageImg || galleryUrls.length < 2) return;
      var startX = null;
      var startY = null;
      var locked = null; // 'h' | 'v'
      stage.addEventListener(
        "touchstart",
        function (e) {
          if (!e.touches || !e.touches[0]) return;
          startX = e.touches[0].clientX;
          startY = e.touches[0].clientY;
          locked = null;
        },
        { passive: true }
      );
      stage.addEventListener(
        "touchmove",
        function (e) {
          if (startX == null || !e.touches || !e.touches[0]) return;
          var dx = e.touches[0].clientX - startX;
          var dy = e.touches[0].clientY - startY;
          if (locked == null && (Math.abs(dx) > 10 || Math.abs(dy) > 10)) {
            locked = Math.abs(dx) > Math.abs(dy) ? "h" : "v";
          }
          if (locked === "h" && e.cancelable) e.preventDefault();
        },
        { passive: false }
      );
      stage.addEventListener(
        "touchend",
        function (e) {
          if (startX == null || !e.changedTouches || !e.changedTouches[0]) return;
          var dx = e.changedTouches[0].clientX - startX;
          var wasH = locked === "h";
          startX = startY = locked = null;
          if (!wasH) return;
          if (Math.abs(dx) < 36) return;
          if (dx < 0) showGalleryIndex(galleryIndex + 1);
          else showGalleryIndex(galleryIndex - 1);
        },
        { passive: true }
      );
    }

    /** Ensure iOS can actually scroll the thumb strip (force layout styles). */
    function wireThumbStrip() {
      var strip = qs("[data-hv2-thumbs]", root);
      if (!strip || thumbs.length < 2) return;
      strip.style.display = "flex";
      strip.style.flexWrap = "nowrap";
      strip.style.overflowX = "scroll";
      strip.style.overflowY = "hidden";
      strip.style.webkitOverflowScrolling = "touch";
      strip.style.touchAction = "pan-x";
    }

    optionRows.forEach(function (row, i) {
      qsa("[data-hv2-opt]", row).forEach(function (btn) {
        btn.addEventListener("click", function () {
          selected[i] = btn.getAttribute("data-value");
          applyVariant(findVariant());
        });
      });
    });

    // Legacy single-option chips
    qsa("[data-hv2-chip]", root).forEach(function (chip) {
      chip.addEventListener("click", function () {
        var id = chip.getAttribute("data-variant-id");
        var v = variants.find(function (x) {
          return String(x.id) === String(id);
        });
        if (v) {
          selected = v.options.slice();
          applyVariant(v);
          qsa("[data-hv2-chip]", root).forEach(function (c) {
            c.classList.toggle("is-selected", c === chip);
          });
        }
      });
    });

    // Default: keep URL/selected id only if available; else first available; else first.
    var initialId = idInput && idInput.value;
    var byId = variants.find(function (v) {
      return String(v.id) === String(initialId);
    });
    var initial =
      (byId && byId.available ? byId : null) ||
      variants.find(function (v) {
        return v.available;
      }) ||
      byId ||
      variants[0];
    if (initial) {
      selected = initial.options.slice();
      applyVariant(initial);
    } else {
      updateUnavailableChips();
      if (stageImg && stageImg.getAttribute("src")) {
        setStageImage(stageImg.getAttribute("src"), { instant: true });
      } else {
        forceStageImgCss();
      }
    }

    /**
     * Premium Set (and similar): availability follows depot PDPs.
     * Shopify set-SKUs are often policy=continue / unlinked from depot stock,
     * so "Original Tabak 18mg" can stay buyable on the set while OOS on the depot PDP.
     * Restrict variants further when either Geschmack@Nikotin is OOS on its depot product.
     */
    (function hydrateDepotComponentStock() {
      var useComponents =
        root.getAttribute("data-hv2-depot-components") === "1" ||
        root.getAttribute("data-product-handle") === "lynden-premium-set";
      if (!useComponents || !variants.length) return;

      var FLAVOR_TO_HANDLE = {
        "Original Tabak": "lynden-depots-original-tabak",
        "Fresh Menthol": "lynden-depots-fresh-menthol",
        "Tabak No.2": "lynden-depots-tabak-no-2",
        "Wild Cherry": "lynden-depots-wild-cherry",
      };

      function nicKey(label) {
        var m = String(label || "").match(/(\d+)\s*mg/i);
        return m ? m[1] : null;
      }

      var needed = {};
      variants.forEach(function (v) {
        var opts = v.options || [];
        [opts[0], opts[1]].forEach(function (flavor) {
          var h = FLAVOR_TO_HANDLE[flavor];
          if (h) needed[h] = true;
        });
      });
      var handles = Object.keys(needed);
      if (!handles.length) return;

      Promise.all(
        handles.map(function (h) {
          return fetch("/products/" + encodeURIComponent(h) + ".js", {
            credentials: "same-origin",
          })
            .then(function (r) {
              return r.ok ? r.json() : null;
            })
            .then(function (product) {
              return { handle: h, product: product };
            })
            .catch(function () {
              return { handle: h, product: null };
            });
        })
      ).then(function (results) {
        var stock = {};
        results.forEach(function (res) {
          if (!res.product || !res.product.variants) return;
          var map = {};
          res.product.variants.forEach(function (dv) {
            var k = nicKey(dv.option1 || dv.title || "");
            if (k != null) map[k] = !!dv.available;
          });
          stock[res.handle] = map;
        });

        variants.forEach(function (v) {
          var opts = v.options || [];
          var f1 = opts[0];
          var f2 = opts[1];
          var k = nicKey(opts[2]);
          var h1 = FLAVOR_TO_HANDLE[f1];
          var h2 = FLAVOR_TO_HANDLE[f2];
          if (!k || !h1 || !h2) return;
          var a1 = stock[h1] && stock[h1][k] === true;
          var a2 = stock[h2] && stock[h2][k] === true;
          if (!a1 || !a2) {
            v.available = false;
            v._componentOos = true;
          }
        });

        var cur = findVariant();
        if (!cur || !cur.available) {
          var next =
            variants.find(function (v) {
              return v.available;
            }) || cur;
          if (next) {
            selected = next.options.slice();
            applyVariant(next);
            return;
          }
        }
        applyVariant(cur || initial);
      });
    })();

    // Hydrate unit price from product.js when Liquid allowlist missed (e.g. type "Pod" prefilled)
    // or when full-page cache is stale. product.js is always fresh.
    (function hydrateUnitFromProductJs() {
      if (!unitPriceEl) return;
      var path = window.location && window.location.pathname;
      if (!path || path.indexOf("/products/") !== 0) return;
      var jsUrl = path.replace(/\/$/, "") + ".js";
      fetch(jsUrl, { credentials: "same-origin" })
        .then(function (r) {
          return r.ok ? r.json() : null;
        })
        .then(function (product) {
          if (!product || !product.variants) return;
          var ptype = String(product.type || "").toLowerCase();
          var ptitle = String(product.title || "").toLowerCase();
          // Deny pure hardware (never invent Grundpreis)
          if (
            /e-zigarette|akkutr|pod-system|hardware|coil|verdampfer/.test(ptype) &&
            !/prefilled|liquid|nikotinsalz|depot/.test(ptype + " " + ptitle)
          ) {
            return;
          }
          product.variants.forEach(function (sfv) {
            var local = variants.find(function (x) {
              return String(x.id) === String(sfv.id);
            });
            if (!local) return;
            if (sfv.unit_price_measurement && sfv.unit_price_measurement.quantity_value) {
              var q = parseFloat(sfv.unit_price_measurement.quantity_value);
              var u = String(sfv.unit_price_measurement.quantity_unit || "").toLowerCase();
              if (q > 0 && (u === "ml" || u === "cl" || u === "l")) {
                local.sf_unit_ml = u === "ml" ? q : u === "cl" ? q * 10 : q * 1000;
                local.sf_unit_price = sfv.unit_price;
              }
            }
          });
          var any = variants.some(function (x) {
            return x.sf_unit_ml != null && Number(x.sf_unit_ml) > 0;
          });
          if (any) {
            root.setAttribute("data-hv2-unit-allowed", "1");
            applyVariant(findVariant() || initial);
          }
        })
        .catch(function () {});
    })();

    thumbs.forEach(function (thumb, i) {
      thumb.addEventListener("click", function () {
        var src = thumb.getAttribute("data-full");
        if (src) setStageImage(src);
        galleryIndex = i;
      });
    });

    wireThumbStrip();
    wireGallerySwipe();
    // Re-apply after layout (Safari sometimes needs a second pass)
    if (stageImg) {
      if (stageImg.complete) forceStageImgCss();
      else stageImg.addEventListener("load", forceStageImgCss, { once: true });
      setTimeout(forceStageImgCss, 50);
      setTimeout(forceStageImgCss, 300);
    }

    qsa("[data-hv2-qty-minus]", root).forEach(function (btn) {
      btn.addEventListener("click", function () {
        if (!qtyInput) return;
        qtyInput.value = Math.max(1, (parseInt(qtyInput.value, 10) || 1) - 1);
      });
    });
    qsa("[data-hv2-qty-plus]", root).forEach(function (btn) {
      btn.addEventListener("click", function () {
        if (!qtyInput) return;
        qtyInput.value = Math.min(99, (parseInt(qtyInput.value, 10) || 1) + 1);
      });
    });

    restructureBody(root);
    // Body copy, FAQ, tech table, chips: always "10mg", never "10 mg/ml"
    normalizeMgMlInTree(root);
    initReviewSlider(root);
    initStickyCta(root);
    // accessories hydration is kicked from restructureBody when links found
  }

  function initStickyCta(root) {
    var bar = qs("[data-hv2-stickycta]", root);
    var mainAtc = qs("[data-hv2-atc]", root);
    var stickyAtc = qs("[data-hv2-sticky-atc]", root);
    var stickyPrice = qs("[data-hv2-sticky-price]", root);
    var priceEl = qs("[data-hv2-price]", root);
    if (!bar || !mainAtc) return;

    function sync() {
      if (stickyPrice && priceEl) stickyPrice.textContent = priceEl.textContent;
      if (stickyAtc) {
        stickyAtc.disabled = mainAtc.disabled;
        stickyAtc.textContent = mainAtc.disabled
          ? mainAtc.getAttribute("data-label-soldout") || "Ausverkauft"
          : "In den Warenkorb";
      }
    }

    if (stickyAtc) {
      stickyAtc.addEventListener("click", function () {
        if (mainAtc.disabled) return;
        // Prefer native form submit so theme cart hooks still run
        var form = qs("[data-hv2-form]", root);
        if (form && typeof form.requestSubmit === "function") form.requestSubmit();
        else if (form) form.submit();
        else mainAtc.click();
      });
    }

    // Keep price/label in sync when variants change
    var obs =
      window.MutationObserver &&
      new MutationObserver(function () {
        sync();
      });
    if (obs && priceEl) obs.observe(priceEl, { childList: true, characterData: true, subtree: true });
    if (obs) obs.observe(mainAtc, { attributes: true, attributeFilter: ["disabled"] });
    sync();

    function isMobile() {
      return window.matchMedia("(max-width: 900px)").matches;
    }

    if ("IntersectionObserver" in window) {
      var io = new IntersectionObserver(
        function (entries) {
          var entry = entries[0];
          var show = isMobile() && entry && !entry.isIntersecting;
          bar.hidden = !show;
          document.documentElement.classList.toggle("lyd-hv2-sticky-on", show);
        },
        { root: null, threshold: 0, rootMargin: "0px" }
      );
      io.observe(mainAtc);
      window.addEventListener("resize", function () {
        if (!isMobile()) {
          bar.hidden = true;
          document.documentElement.classList.remove("lyd-hv2-sticky-on");
        }
      });
    }
  }

  function parseOkendoReviews(html) {
    if (!html || !window.DOMParser) return [];
    var doc = new DOMParser().parseFromString(html, "text/html");
    var items = doc.querySelectorAll(".oke-w-reviews-list-item");
    var out = [];
    Array.prototype.forEach.call(items, function (li) {
      var nameEl = li.querySelector(".oke-w-reviewer-name");
      var titleEl = li.querySelector(".oke-reviewContent-title");
      var bodyEl = li.querySelector(".oke-reviewContent-body");
      var name = nameEl ? nameEl.textContent.replace(/\s+/g, " ").trim() : "";
      var title = titleEl ? titleEl.textContent.replace(/\s+/g, " ").trim() : "";
      var body = bodyEl ? bodyEl.textContent.replace(/\s+/g, " ").trim() : "";
      body = body.replace(/\s*Weiterlesen.*$/i, "").trim();
      if (body.length < 24 && title) body = title;
      if (body.length < 24) return;
      var starMatch = (li.textContent || "").match(/Mit\s+(\d)\s+von\s+5/i);
      var stars = starMatch ? parseInt(starMatch[1], 10) : 5;
      if (stars < 4) return; // teaser: only strong reviews
      out.push({
        name: name || "Kunde",
        title: title,
        body: body.length > 200 ? body.slice(0, 197) + "…" : body,
        stars: stars,
      });
    });
    return out.slice(0, 8);
  }

  function initReviewSlider(root) {
    var slider = qs("[data-hv2-revslider]", root);
    if (!slider || slider.dataset.ready === "1") return;
    var source = qs("[data-hv2-oke-source]", slider);
    var track = qs("[data-hv2-revslider-track]", slider);
    if (!source || !track) return;

    var reviews = parseOkendoReviews(source.innerHTML);
    if (reviews.length < 2) {
      slider.hidden = true;
      return;
    }
    slider.dataset.ready = "1";
    source.innerHTML = ""; // drop heavy HTML after parse

    reviews.forEach(function (r) {
      var card = document.createElement("article");
      card.className = "lyd-hv2__revcard";
      var stars = "★★★★★".slice(0, r.stars) + "☆☆☆☆☆".slice(r.stars);
      card.innerHTML =
        '<div class="lyd-hv2__revcard-stars" aria-hidden="true">' +
        stars +
        "</div>" +
        (r.title
          ? '<p class="lyd-hv2__revcard-title">' + escapeHtml(r.title) + "</p>"
          : "") +
        '<p class="lyd-hv2__revcard-body">“' +
        escapeHtml(r.body) +
        '”</p>' +
        '<p class="lyd-hv2__revcard-name">' +
        escapeHtml(r.name) +
        "</p>";
      track.appendChild(card);
    });

    var viewport = qs(".lyd-hv2__revslider-viewport", slider) || track.parentElement;
    var index = 0;
    var useNativeScroll = window.matchMedia("(max-width: 900px)").matches;
    var inView = true;

    function cardWidth() {
      var c = track.querySelector(".lyd-hv2__revcard");
      if (!c) return 320;
      var style = window.getComputedStyle(track);
      var gap = parseFloat(style.columnGap || style.gap || "16") || 16;
      return c.getBoundingClientRect().width + gap;
    }

    /**
     * Horizontal advance only — never scrollIntoView (that jumps the page
     * vertically on mobile when autoplay fires).
     */
    function scrollViewportToIndex(i) {
      if (!viewport) return;
      var c = track.children[i];
      if (!c) return;
      var pad = parseFloat(window.getComputedStyle(viewport).paddingLeft) || 0;
      var vRect = viewport.getBoundingClientRect();
      var cRect = c.getBoundingClientRect();
      var target = viewport.scrollLeft + (cRect.left - vRect.left) - pad;
      if (typeof viewport.scrollTo === "function") {
        viewport.scrollTo({ left: Math.max(0, target), behavior: "smooth" });
      } else {
        viewport.scrollLeft = Math.max(0, target);
      }
    }

    function go(i, opts) {
      var max = Math.max(0, reviews.length - 1);
      index = Math.max(0, Math.min(max, i));
      var instant = opts && opts.instant;
      if (useNativeScroll && viewport) {
        if (instant) {
          var c = track.children[index];
          if (c) {
            var pad = parseFloat(window.getComputedStyle(viewport).paddingLeft) || 0;
            var vRect = viewport.getBoundingClientRect();
            var cRect = c.getBoundingClientRect();
            viewport.scrollLeft = Math.max(
              0,
              viewport.scrollLeft + (cRect.left - vRect.left) - pad
            );
          }
        } else {
          scrollViewportToIndex(index);
        }
      } else {
        track.style.transform = "translateX(" + -index * cardWidth() + "px)";
      }
    }
    var prev = qs("[data-hv2-rev-prev]", slider);
    var next = qs("[data-hv2-rev-next]", slider);
    if (prev)
      prev.addEventListener("click", function () {
        go(index - 1);
      });
    if (next)
      next.addEventListener("click", function () {
        go(index + 1);
      });
    window.addEventListener("resize", function () {
      useNativeScroll = window.matchMedia("(max-width: 900px)").matches;
      if (!useNativeScroll) go(index, { instant: true });
    });

    // Keep index in sync when user swipes the track manually
    if (viewport) {
      var scrollSyncTimer = null;
      viewport.addEventListener(
        "scroll",
        function () {
          if (!useNativeScroll) return;
          if (scrollSyncTimer) clearTimeout(scrollSyncTimer);
          scrollSyncTimer = setTimeout(function () {
            var cards = track.children;
            if (!cards.length) return;
            var vMid = viewport.getBoundingClientRect().left + viewport.clientWidth / 2;
            var best = 0;
            var bestDist = Infinity;
            for (var i = 0; i < cards.length; i++) {
              var r = cards[i].getBoundingClientRect();
              var mid = r.left + r.width / 2;
              var d = Math.abs(mid - vMid);
              if (d < bestDist) {
                bestDist = d;
                best = i;
              }
            }
            index = best;
          }, 80);
        },
        { passive: true }
      );
    }

    // Autoplay only while slider is on screen — never scroll the document
    var reduce =
      window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (!reduce) {
      if ("IntersectionObserver" in window) {
        var io = new IntersectionObserver(
          function (entries) {
            var e = entries[0];
            inView = !!(e && e.isIntersecting && e.intersectionRatio > 0.15);
          },
          { threshold: [0, 0.15, 0.5] }
        );
        io.observe(slider);
      }
      var timer = setInterval(function () {
        if (document.hidden || !inView) return;
        if (index >= reviews.length - 1) go(0);
        else go(index + 1);
      }, 6000);
      function stopAuto() {
        clearInterval(timer);
      }
      slider.addEventListener("mouseenter", stopAuto);
      slider.addEventListener("touchstart", stopAuto, { passive: true });
      slider.addEventListener("pointerdown", stopAuto);
    }
  }

  function escapeHtml(s) {
    return String(s)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;");
  }

  /**
   * Transform legacy lyd-pdp description into mockup body order:
   * marketing sections → (details/FAQ already in liquid) filled from stripped parts
   * Hides: raw §14 banner, Pflichtinformationen stack, side "Technische Daten" card, trust wall
   */
  function restructureBody(root) {
    var desc = qs("[data-hv2-desc]", root);
    var out = qs("[data-hv2-body-out]", root);
    if (!desc || !out || desc.dataset.hv2Done === "1") return;
    desc.dataset.hv2Done = "1";

    // Keep a single FAQPage JSON-LD (from product body); drop other scripts/styles
    var faqJsonLd = null;
    qsa("style, script", desc).forEach(function (el) {
      if (
        !faqJsonLd &&
        el.tagName === "SCRIPT" &&
        /application\/ld\+json/i.test(el.getAttribute("type") || "") &&
        /FAQPage/i.test(el.textContent || "")
      ) {
        faqJsonLd = el;
        return;
      }
      if (el.parentNode) el.parentNode.removeChild(el);
    });

    // Collect pieces to rehome
    var warn = qs(".lyd-warn", desc);
    var compliance = qs(".lyd-compliance", desc);
    var specsCard = qs(".lyd-specs-card", desc);
    var side = qs(".lyd-cols-side", desc);
    var trust = qs(".lyd-trust", desc);
    // FAQ only from dedicated FAQ blocks — never GPSR/compliance (those → Sonstige Details)
    var faqDetails = qsa(".lyd-faq-block details, .lyd-faq details", desc);

    // Tech rows from side card → sticky sidebar "Technische Daten"
    var techTable = qs("[data-hv2-tech-table]", root);
    var techCard = qs("[data-hv2-tech-card]", root);

    function isPlaceholderSpec(v) {
      v = String(v || "")
        .replace(/\s+/g, " ")
        .trim()
        .toLowerCase();
      if (!v) return true;
      // bare placeholders or "x ml", "x mm", "x mAh"
      if (/^(x|-|–|—|n\/a|n\.a\.|na|k\.?a\.?|unbekannt|none|null|undefined)$/i.test(v)) {
        return true;
      }
      if (/^x(\s|$)/i.test(v)) return true;
      return false;
    }

    function isNicotineLabel(label) {
      var l = String(label || "")
        .toLowerCase()
        .replace(/\s+/g, " ")
        .trim();
      // "Nikotinstärken", "Nikotinstärke …" OR bare Shopify option "Stärke"
      if (/nikotin/.test(l)) return true;
      if (/^(stärke|staerke|stärken|staerken)$/.test(l)) return true;
      return false;
    }

    /** Normalize strengths to "0mg, 6mg, 12mg" (never mg/ml or "X mg (nikotinfrei)"). */
    function formatNicotineStrengths(val) {
      var s = String(val || "");
      var found = [];
      var seen = {};
      var re = /(\d+(?:[.,]\d+)?)\s*mg(?:\s*\/\s*ml)?/gi;
      var m;
      while ((m = re.exec(s)) !== null) {
        var raw = m[1].replace(",", ".");
        var n =
          raw.indexOf(".") >= 0
            ? String(parseFloat(raw))
            : String(parseInt(raw, 10));
        if (seen[n]) continue;
        seen[n] = true;
        found.push(n + "mg");
      }
      if (!found.length) return s.replace(/\s+/g, " ").trim();
      found.sort(function (a, b) {
        return parseFloat(a) - parseFloat(b);
      });
      return found.join(", ");
    }

    function normSpecLabel(label) {
      var l = String(label || "")
        .toLowerCase()
        .replace(/\s+/g, " ")
        .trim();
      if (isNicotineLabel(l)) return "nikotinstärken";
      return l;
    }

    function isJunkShopifySpec(label, val) {
      var l = String(label || "")
        .toLowerCase()
        .replace(/\s+/g, " ")
        .trim();
      var v = String(val || "")
        .toLowerCase()
        .replace(/\s+/g, " ")
        .trim();
      if (l === "title" || v === "default title") return true;
      return false;
    }

    function scrubTechTable(table) {
      if (!table) return;
      var nicKeep = null;
      var hasProdukttyp = false;
      qsa("tr", table).forEach(function (tr) {
        var tds = tr.querySelectorAll("td");
        if (tds.length < 2) return;
        var lab = (tds[0].textContent || "").trim().toLowerCase();
        if (lab === "produkttyp") hasProdukttyp = true;
      });
      qsa("tr", table).forEach(function (tr) {
        var tds = tr.querySelectorAll("td");
        if (tds.length < 2) return;
        var label = (tds[0].textContent || "").trim();
        var val = (tds[1].textContent || "").trim();
        if (isJunkShopifySpec(label, val)) {
          if (tr.parentNode) tr.parentNode.removeChild(tr);
          return;
        }
        if (hasProdukttyp && /^typ$/i.test(label)) {
          if (tr.parentNode) tr.parentNode.removeChild(tr);
          return;
        }
        if (isPlaceholderSpec(val)) {
          if (tr.parentNode) tr.parentNode.removeChild(tr);
          return;
        }
        if (isNicotineLabel(label)) {
          var formatted = formatNicotineStrengths(val);
          if (!nicKeep) {
            tds[0].textContent = "Nikotinstärken";
            tds[1].textContent = formatted;
            nicKeep = tr;
          } else {
            // merge any extra strengths into the kept row, then drop dupe
            var merged = formatNicotineStrengths(
              (nicKeep.querySelectorAll("td")[1].textContent || "") +
                ", " +
                formatted
            );
            nicKeep.querySelectorAll("td")[1].textContent = merged;
            if (tr.parentNode) tr.parentNode.removeChild(tr);
          }
        }
      });
    }

    /**
     * Force visible row dividers (incl. Nikotinstärken → Produkttyp).
     * Insert real 1px separator <tr>s — CSS borders alone were unreliable on desktop.
     */
    function paintTechDividers(table) {
      if (!table) return;
      // drop previous seps (re-entrant / re-run safe)
      qsa("tr.lyd-hv2__dtable-sep", table).forEach(function (tr) {
        if (tr.parentNode) tr.parentNode.removeChild(tr);
      });
      var rows = qsa("tr", table).filter(function (tr) {
        return !tr.classList.contains("lyd-hv2__dtable-sep");
      });
      // insert separator before every row after the first
      for (var i = rows.length - 1; i >= 1; i--) {
        var sep = document.createElement("tr");
        sep.className = "lyd-hv2__dtable-sep";
        sep.setAttribute("aria-hidden", "true");
        var td = document.createElement("td");
        td.colSpan = 2;
        td.style.cssText =
          "padding:0!important;margin:0!important;height:1px!important;line-height:0!important;font-size:0!important;border:0!important;background:#d0ccc6!important;box-shadow:none!important;";
        sep.appendChild(td);
        rows[i].parentNode.insertBefore(sep, rows[i]);
      }
      // tidy cell padding on data rows
      rows.forEach(function (tr) {
        var tds = tr.querySelectorAll("td");
        for (var j = 0; j < tds.length; j++) {
          tds[j].style.paddingTop = "11px";
          tds[j].style.paddingBottom = "11px";
        }
      });
    }

    if (techTable && specsCard) {
      qsa(".lyd-spec-row", specsCard).forEach(function (row) {
        var cells = row.children;
        if (!cells || cells.length < 2) return;
        var label = (cells[0].textContent || "").trim();
        var val = (cells[1].textContent || "").trim();
        if (!label || isPlaceholderSpec(val)) return;
        if (isNicotineLabel(label)) {
          val = formatNicotineStrengths(val);
          label = "Nikotinstärken";
        }
        // skip duplicates already in table (incl. nicotine label variants)
        var exists = false;
        var key = normSpecLabel(label);
        qsa("tr", techTable).forEach(function (r) {
          var t = qs("td", r);
          if (t && normSpecLabel(t.textContent) === key) exists = true;
        });
        if (exists) return;
        var tr = document.createElement("tr");
        var td1 = document.createElement("td");
        var td2 = document.createElement("td");
        td1.textContent = label;
        td2.textContent = val;
        tr.appendChild(td1);
        tr.appendChild(td2);
        techTable.appendChild(tr);
      });
    }
    // Always drop placeholder rows (metafield "x", body specs, merges)
    // and collapse/format nicotine rows to a single "0mg, 6mg, …" line.
    scrubTechTable(techTable);
    paintTechDividers(techTable);
    if (techCard && techTable && !qsa("tr", techTable).length) {
      techCard.hidden = true;
    }

    // Lieferumfang → sticky sidebar box card
    var boxCard = qs("[data-hv2-box-card]", root);
    var boxList = qs("[data-hv2-box-list]", root);
    function appendBoxItem(text, isNote) {
      if (!boxList || !text) return;
      if (isNote) {
        var note = document.createElement("span");
        note.className = "lyd-hv2__boxnote";
        note.textContent = text;
        boxList.appendChild(note);
        return;
      }
      // skip duplicates
      var exists = false;
      qsa("li", boxList).forEach(function (li) {
        if ((li.textContent || "").trim() === text) exists = true;
      });
      if (exists) return;
      var li = document.createElement("li");
      li.innerHTML =
        '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M20 6L9 17l-5-5" fill="none" stroke="currentColor" stroke-width="2.5"/></svg>';
      var span = document.createElement("span");
      span.textContent = text;
      li.appendChild(span);
      boxList.appendChild(li);
    }
    function fillBoxFromSection(sec) {
      if (!sec || !boxList) return false;
      var found = false;
      qsa("li", sec).forEach(function (li) {
        var t = (li.textContent || "").replace(/\s+/g, " ").trim();
        if (!t) return;
        appendBoxItem(t, false);
        found = true;
      });
      qsa(".lyd-note, .note", sec).forEach(function (n) {
        var t = (n.textContent || "").replace(/\s+/g, " ").trim();
        if (t) {
          appendBoxItem(t, true);
          found = true;
        }
      });
      return found;
    }

    // Safety / §14 + Pflichtangaben → safety accordion (collapsed, mockup style)
    var safetyInner = qs("[data-hv2-safety-inner]", root);
    if (safetyInner) {
      // remove helper note
      var note = qs(".lyd-hv2__acc-note", safetyInner);
      if (note) note.parentNode.removeChild(note);
      if (warn) {
        var w = document.createElement("div");
        w.className = "lyd-hv2__legal-item";
        w.innerHTML =
          "<p><b>Warnhinweis nach § 14 TabakerzG</b></p>" +
          "<p>" +
          (warn.textContent || "").replace(/\s+/g, " ").trim() +
          "</p>";
        safetyInner.appendChild(w);
      }
      if (compliance) {
        // move details that aren't pure FAQ into safety
        var c = document.createElement("div");
        c.className = "lyd-hv2__legal-item";
        // clone non-faq prose + details about Pflichtangaben/CLP
        qsa("details", compliance).forEach(function (d) {
          var sum = qs("summary", d);
          var title = sum ? sum.textContent.trim() : "";
          if (/häufige fragen|faq/i.test(title)) return;
          c.appendChild(d.cloneNode(true));
        });
        if (c.childNodes.length) safetyInner.appendChild(c);
      }
    }

    // FAQ → mockup FAQ host
    var faqHost = qs("[data-hv2-faq-host]", root);
    var faqAcc = qs("[data-hv2-faq-acc]", root);
    if (faqHost && faqAcc) {
      var moved = 0;
      faqDetails.forEach(function (d) {
        var sum = qs("summary", d);
        var title = sum ? sum.textContent.trim() : "";
        if (!title) return;
        // only genuine FAQs — never legal/GPSR/safety into FAQ host
        if (
          /pflichtangaben|inhaltsstoffe|clp|kennzeichnung|gpsr|hersteller|sicherheit|verantwortliche|tabakerzg|§\s*14|warnhinweis/i.test(
            title
          )
        ) {
          return;
        }
        // skip details that live inside .lyd-compliance (belt + suspenders)
        if (d.closest && d.closest(".lyd-compliance")) {
          return;
        }
        var clone = d.cloneNode(true);
        // normalize summary icon
        var s = qs("summary", clone);
        if (s && !qs(".lyd-hv2__acc-ico", s)) {
          s.innerHTML =
            s.textContent.trim() +
            ' <span class="lyd-hv2__acc-ico" aria-hidden="true"></span>';
        }
        faqAcc.appendChild(clone);
        moved++;
      });
      if (moved > 0) {
        faqHost.hidden = false;
      }
    }

    // Build marketing body from product description — preserve all editorial content.
    // Legal/FAQ/tech are also rehomed into mockup accordions above (still on page).
    var main = qs(".lyd-cols-main", desc) || desc;
    var keep = document.createElement("div");
    keep.className = "lyd-hv2__body lyd-hv2__body--ready";

    // Accessories (Pods/Cartridges) → product cards with ATC (not text links)
    var accHandles = [];
    var accCollectionHref = "";
    var accCollectionLabel = "";

    // Prefer section nodes under main (structured PDP HTML)
    var sections = qsa(".lyd-section", main);
    if (sections.length) {
      sections.forEach(function (sec) {
        // skip sections that are only compliance wrappers (moved to safety accordion)
        if (sec.classList.contains("lyd-compliance")) return;
        if (qs(".lyd-warn", sec) && !qs("h2", sec) && !qs("p", sec)) return;
        // Skip "Alternativen" — harness shows related products further down
        var labelEl = qs(".lyd-section__label", sec);
        var h2El = qs("h2", sec);
        var label = labelEl ? labelEl.textContent.trim() : "";
        var h2 = h2El ? h2El.textContent.trim() : "";
        if (
          /alternativen/i.test(label) ||
          /weitere\s+(lynden\s+)?geräte|ähnliche produkte|weitere modelle/i.test(
            h2
          )
        ) {
          return;
        }
        // FAQ lives once in the FAQ host — never leave a second copy in main body
        if (
          /faq|häufige fragen/i.test(label) ||
          /häufige fragen|faq/i.test(h2) ||
          qs(".lyd-faq, .lyd-faq-block", sec)
        ) {
          return;
        }
        // Lieferumfang → sidebar card (not main copy)
        if (
          /lieferumfang/i.test(label) ||
          /lieferumfang|was\s+(liegt|ist)\s+in\s+der\s+box/i.test(h2)
        ) {
          if (fillBoxFromSection(sec) && boxCard) boxCard.hidden = false;
          return;
        }
        // Zubehör section only (label) → ATC grid. Keep editorial "Pods"-content sections.
        if (
          /^(zubehör|zubehoer)(\s|&|$)/i.test(label) ||
          /pods,\s*liquids und weitere|passende pods &amp; cartridges|passende pods & cartridges/i.test(
            h2
          )
        ) {
          qsa('a[href*="/products/"]', sec).forEach(function (a) {
            var m = (a.getAttribute("href") || "").match(
              /\/products\/([^\/?#]+)/
            );
            if (m && m[1] && accHandles.indexOf(m[1]) === -1) {
              accHandles.push(m[1]);
            }
          });
          var collA = qs('a[href*="/collections/"]', sec);
          if (collA) {
            accCollectionHref = collA.getAttribute("href") || "";
            accCollectionLabel = (collA.textContent || "").trim();
          }
          return;
        }
        // Skip redundant "Farben" / "Varianten" blocks — selection is in the buybox
        if (isRedundantVariantSection(label, h2, sec)) {
          return;
        }
        keep.appendChild(sec.cloneNode(true));
      });
    } else {
      keep.innerHTML = main.innerHTML;
    }

    // Fallback: box list still embedded in main HTML
    if (boxList && !qsa("li", boxList).length) {
      var boxSec =
        qs(".lyd-box-list", desc) ||
        qs(".lyd-box-list", keep) ||
        qs('[class*="box-list"]', keep);
      if (boxSec) {
        var parentSec = boxSec.closest(".lyd-section") || boxSec.parentNode;
        if (fillBoxFromSection(parentSec || boxSec) && boxCard) {
          boxCard.hidden = false;
        }
        if (parentSec && parentSec.parentNode && parentSec !== keep) {
          // remove from marketing column if it was cloned there
        }
        qsa(".lyd-box-list, .lyd-section", keep).forEach(function (el) {
          var h = qs("h2, .lyd-section__label", el);
          var t = h ? h.textContent : "";
          if (/lieferumfang/i.test(t + " " + (el.className || ""))) {
            if (el.parentNode) el.parentNode.removeChild(el);
          }
        });
      }
    }
    if (boxCard && boxList && qsa("li", boxList).length) {
      boxCard.hidden = false;
    }

    // Final scrub: only remove nodes already rehomed to accordions (not marketing copy)
    qsa(
      ".lyd-warn, .lyd-compliance, .lyd-specs-card, .lyd-cols-side, .lyd-faq-block, .lyd-faq-label, .lyd-faq, script[type='application/ld+json']",
      keep
    ).forEach(function (el) {
      if (el.parentNode) el.parentNode.removeChild(el);
    });
    // Drop any leftover FAQ heading blocks in marketing body
    qsa("h2, h3, .lyd-section__label", keep).forEach(function (el) {
      var t = (el.textContent || "").trim();
      if (!/häufige fragen|^faq$/i.test(t)) return;
      var sec = el.closest(".lyd-section") || el.parentNode;
      if (sec && sec.parentNode && sec !== keep) {
        sec.parentNode.removeChild(sec);
      } else if (el.parentNode) {
        el.parentNode.removeChild(el);
      }
    });

    // Pods CTA boxes ("Pods ansehen" + long teaser) — product name belongs in
    // accessories cards; extract handle then drop the whole card.
    qsa(".lyd-pods-cta", keep).forEach(function (cta) {
      qsa('a[href*="/products/"]', cta).forEach(function (a) {
        var m = (a.getAttribute("href") || "").match(/\/products\/([^\/?#]+)/);
        if (m && m[1] && accHandles.indexOf(m[1]) === -1) {
          accHandles.push(m[1]);
        }
      });
      // also pull name from strong if no link handle found
      var prev = cta.previousElementSibling;
      if (
        prev &&
        prev.tagName === "P" &&
        /ersatzpod|nachkauf|gleich mit in den warenkorb/i.test(
          prev.textContent || ""
        )
      ) {
        if (prev.parentNode) prev.parentNode.removeChild(prev);
      }
      if (cta.parentNode) cta.parentNode.removeChild(cta);
    });

    // Generic "X ansehen" product links → use product name as link text
    qsa('a[href*="/products/"]', keep).forEach(function (a) {
      var t = (a.textContent || "").replace(/\s+/g, " ").trim();
      if (!/ansehen/i.test(t) && !/^zum gerät$/i.test(t)) return;
      // Prefer nearby strong product title, else shorten "Foo ansehen" → "Foo"
      var name = "";
      var box = a.closest(".lyd-pods-cta, .lyd-section, p, li, div");
      if (box) {
        var strong = qs("strong", box);
        if (strong) {
          name = (strong.textContent || "").replace(/\s+/g, " ").trim();
          name = name.replace(/^passende\s+/i, "");
        }
      }
      if (!name) {
        name = t
          .replace(/\s*ansehen\s*→?\s*$/i, "")
          .replace(/^zum gerät$/i, "")
          .trim();
      }
      if (name) {
        a.textContent = name;
      }
    });

    // Spec chips/pills (e.g. "1.300 mAh Akku", "USB-C laden") duplicate the sidebar table
    qsa(
      ".lyd-intro-chips, .lyd-hero__chips, .lyd-pills, .lyd-intro-chip, .lyd-chip",
      keep
    ).forEach(function (el) {
      // remove whole chip row containers; skip lone chips already inside a removed parent
      if (!el.parentNode) return;
      if (
        el.classList.contains("lyd-intro-chips") ||
        el.classList.contains("lyd-hero__chips") ||
        el.classList.contains("lyd-pills")
      ) {
        el.parentNode.removeChild(el);
        return;
      }
      // orphan single chips sitting as direct children of a section
      var parent = el.parentNode;
      if (
        parent &&
        (!parent.classList ||
          (!parent.classList.contains("lyd-intro-chips") &&
            !parent.classList.contains("lyd-pills") &&
            !parent.classList.contains("lyd-hero__chips")))
      ) {
        // only strip if the chip looks like a short tech fact (not a CTA pill)
        var t = (el.textContent || "").replace(/\s+/g, " ").trim();
        if (
          t.length < 48 &&
          /(mah|watt|\bw\b|ml|usb|pod|akku|display|ohm|nikotin)/i.test(t)
        ) {
          el.parentNode.removeChild(el);
        }
      }
    });
    // Keep .lyd-trust in marketing if present (social proof) — only strip empty shells
    qsa(".lyd-trust", keep).forEach(function (el) {
      if (!(el.textContent || "").trim() && el.parentNode) {
        el.parentNode.removeChild(el);
      }
    });
    // remove trailing FAQ/legal details left in marketing (already in FAQ/safety host)
    qsa("details", keep).forEach(function (d) {
      var sum = qs("summary", d);
      var t = sum ? sum.textContent : "";
      if (
        /pflicht|inhaltsstoff|clp|warnhinweis|§\s*14|häufige fragen/i.test(t)
      ) {
        if (d.parentNode) d.parentNode.removeChild(d);
      }
    });

    // Safety net: never leave an empty body if description had content
    if (!keep.textContent || !keep.textContent.replace(/\s+/g, "").length) {
      keep.innerHTML = main.innerHTML;
      qsa("style, script", keep).forEach(function (el) {
        if (el.parentNode) el.parentNode.removeChild(el);
      });
    }

    // Scrub any leftover text-only related-link lists for pods/accessories
    qsa(".lyd-related-links", keep).forEach(function (box) {
      var h = qs("h2, h3", box) || box.previousElementSibling;
      var t = h ? h.textContent : "";
      if (/pods|cartridges|zubehör/i.test(t + " " + (box.textContent || ""))) {
        // also pull handles if we missed them
        qsa('a[href*="/products/"]', box).forEach(function (a) {
          var m = (a.getAttribute("href") || "").match(/\/products\/([^\/?#]+)/);
          if (m && m[1] && accHandles.indexOf(m[1]) === -1) {
            accHandles.push(m[1]);
          }
        });
        if (box.parentNode) box.parentNode.removeChild(box);
      }
    });

    // Strip residual "Farben / n Varianten — Auswahl im Kaufen-Bereich" copy
    scrubRedundantVariantCopy(keep);

    // Drop placeholder spec rows (Tankvolumen x, Gehäuse x, …) from marketing body
    qsa(".lyd-spec-row", keep).forEach(function (row) {
      var cells = row.children;
      if (!cells || cells.length < 2) return;
      var val = (cells[1].textContent || "").trim();
      if (isPlaceholderSpec(val)) {
        if (row.parentNode) row.parentNode.removeChild(row);
      }
    });

    out.appendChild(keep);
    // Critical for SEO: do not leave a second full copy of the description in the DOM
    // (hidden source was still crawlable and duplicated main content / FAQ / H2s).
    desc.innerHTML = "";
    desc.hidden = true;
    desc.setAttribute("aria-hidden", "true");
    // Re-attach one FAQPage schema after source wipe (not inside main copy)
    if (faqJsonLd && !document.getElementById("lyd-hv2-faq-jsonld")) {
      faqJsonLd.id = "lyd-hv2-faq-jsonld";
      var faqHostEl = qs("[data-hv2-faq-host]", root);
      if (faqHostEl && faqHostEl.parentNode) {
        faqHostEl.parentNode.insertBefore(faqJsonLd, faqHostEl.nextSibling);
      } else if (out.parentNode) {
        out.parentNode.appendChild(faqJsonLd);
      } else {
        document.body.appendChild(faqJsonLd);
      }
    }
    scrubTechTable(techTable);
    if (techCard && techTable && !qsa("tr", techTable).length) {
      techCard.hidden = true;
    }

    // remove orphan side/trust from original tree
    [warn, compliance, specsCard, side, trust].forEach(function (el) {
      if (el && el.parentNode) el.parentNode.removeChild(el);
    });

    if (accHandles.length) {
      hydrateAccessories(root, accHandles, accCollectionHref, accCollectionLabel);
    }
  }

  /**
   * Description blocks like "Farben" / "Varianten" that only point to the buybox.
   */
  function isRedundantVariantSection(label, h2, sec) {
    var title = ((label || "") + " " + (h2 || "")).trim();
    var body = (sec && sec.textContent) || "";
    if (/^(farben|varianten|farbvarianten|farbauswahl)$/i.test((h2 || "").trim())) {
      return true;
    }
    if (/^(farben|varianten)$/i.test((label || "").trim())) {
      return true;
    }
    if (
      /farben|varianten|farbvarianten/i.test(title) &&
      /kaufen-bereich|auswahl im|im kaufbereich|buy.?box/i.test(body)
    ) {
      return true;
    }
    // Short section that only lists color count + buybox pointer
    if (
      /farben|varianten/i.test(title) &&
      body.replace(/\s+/g, " ").length < 280 &&
      /\d+\s*varianten|\d+\s*farben/i.test(body)
    ) {
      return true;
    }
    return false;
  }

  function scrubRedundantVariantCopy(keep) {
    if (!keep) return;
    // Headings: Farben / Varianten + their following short buybox note
    qsa("h2, h3, .lyd-section__label", keep).forEach(function (el) {
      var t = (el.textContent || "").trim();
      if (!/^(farben|varianten|farbvarianten|farbauswahl)$/i.test(t)) return;
      var section = el.closest(".lyd-section") || el.parentNode;
      if (section && section !== keep && /lyd-section/i.test(section.className || "")) {
        if (section.parentNode) section.parentNode.removeChild(section);
        return;
      }
      // remove heading + next siblings until next heading/section
      var node = el;
      var stop = false;
      while (node && !stop) {
        var next = node.nextSibling;
        if (node.parentNode) node.parentNode.removeChild(node);
        node = next;
        if (!node) break;
        if (node.nodeType === 1) {
          var tag = (node.tagName || "").toLowerCase();
          if (
            tag === "h2" ||
            tag === "h3" ||
            (node.classList && node.classList.contains("lyd-section"))
          ) {
            stop = true;
          }
        }
      }
    });
    // Paragraphs that only say "n Varianten — Auswahl im Kaufen-Bereich"
    qsa("p", keep).forEach(function (p) {
      var t = (p.textContent || "").replace(/\s+/g, " ").trim();
      if (
        /auswahl im kaufen-bereich|im kaufen-bereich/i.test(t) ||
        (/^\d+\s*varianten/i.test(t) && /auswahl|kaufen/i.test(t)) ||
        (/^\d+\s*farben/i.test(t) && t.length < 160)
      ) {
        if (p.parentNode) p.parentNode.removeChild(p);
      }
    });
    // List items like "Farben: Schwarz, …" that only restate the option list
    qsa("li", keep).forEach(function (li) {
      var t = (li.textContent || "").replace(/\s+/g, " ").trim();
      if (
        /^(farbe|farben|variante|varianten)\s*:/i.test(t) &&
        /kaufen-bereich|auswahl im/i.test(t)
      ) {
        if (li.parentNode) li.parentNode.removeChild(li);
      }
    });
  }

  function moneyFormat(cents) {
    try {
      var rootEl = document.querySelector(".lyd-hv2");
      var fmt =
        (rootEl && rootEl.getAttribute("data-money-format")) ||
        (window.theme && theme.moneyFormat) ||
        null;
      if (window.Shopify && typeof Shopify.formatMoney === "function" && fmt) {
        return Shopify.formatMoney(cents, fmt);
      }
    } catch (e) {}
    var n = (Number(cents) / 100).toFixed(2).replace(".", ",");
    return n + " €";
  }

  /**
   * Load accessory products by handle and render mobile-friendly ATC cards.
   */
  function hydrateAccessories(root, handles, collHref, collLabel) {
    var host = qs("[data-hv2-accs]", root);
    var grid = qs("[data-hv2-accs-grid]", root);
    var note = qs("[data-hv2-accs-note]", root);
    var link = qs("[data-hv2-accs-link]", root);
    if (!host || !grid || !handles.length) return;

    var unique = [];
    handles.forEach(function (h) {
      if (h && unique.indexOf(h) === -1) unique.push(h);
    });
    unique = unique.slice(0, 8);

    Promise.all(
      unique.map(function (handle) {
        return fetch("/products/" + encodeURIComponent(handle) + ".js", {
          credentials: "same-origin",
        })
          .then(function (r) {
            if (!r.ok) throw new Error("missing " + handle);
            return r.json();
          })
          .catch(function () {
            return null;
          });
      })
    ).then(function (products) {
      products = products.filter(Boolean);
      if (!products.length) return;

      grid.innerHTML = "";
      products.forEach(function (p) {
        var v =
          (p.variants || []).find(function (x) {
            return x.available;
          }) ||
          (p.variants && p.variants[0]);
        if (!v) return;
        var img =
          (typeof p.featured_image === "string" && p.featured_image) ||
          (p.featured_image && p.featured_image.src) ||
          (p.images && p.images[0] && (p.images[0].src || p.images[0])) ||
          "";
        if (img && img.indexOf("//") === 0) img = "https:" + img;

        var price = moneyFormat(v.price);
        var compare =
          v.compare_at_price && v.compare_at_price > v.price
            ? moneyFormat(v.compare_at_price)
            : "";
        var available = !!v.available;

        var card = document.createElement("article");
        card.className =
          "lyd-hv2__accs-card" + (available ? "" : " is-out");
        card.innerHTML =
          '<a class="lyd-hv2__accs-img" href="/products/' +
          encodeURIComponent(p.handle) +
          '" tabindex="-1" aria-hidden="true">' +
          (img
            ? '<img src="' +
              img +
              '" alt="" width="180" height="180" loading="lazy">'
            : "") +
          "</a>" +
          '<div class="lyd-hv2__accs-body">' +
          '<a class="lyd-hv2__accs-title" href="/products/' +
          encodeURIComponent(p.handle) +
          '">' +
          escapeHtml(p.title) +
          "</a>" +
          (p.vendor
            ? '<span class="lyd-hv2__accs-vendor">' +
              escapeHtml(p.vendor) +
              "</span>"
            : "") +
          '<div class="lyd-hv2__accs-price">' +
          (compare ? "<s>" + compare + "</s> " : "") +
          price +
          "</div>" +
          '<button type="button" class="lyd-hv2__accs-atc" data-variant-id="' +
          v.id +
          '"' +
          (available ? "" : " disabled") +
          ">" +
          (available ? "In den Warenkorb" : "Ausverkauft") +
          "</button>" +
          "</div>";

        var btn = card.querySelector(".lyd-hv2__accs-atc");
        if (btn && available) {
          btn.addEventListener("click", function () {
            var id = Number(btn.getAttribute("data-variant-id"));
            if (!id) return;
            var original = btn.textContent;
            btn.disabled = true;
            btn.textContent = "…";
            fetch("/cart/add.js", {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                Accept: "application/json",
              },
              credentials: "same-origin",
              body: JSON.stringify({ items: [{ id: id, quantity: 1 }] }),
            })
              .then(function (r) {
                if (!r.ok) throw new Error("add failed");
                return r.json();
              })
              .then(function () {
                // Full cart path (drawer hidden on DEV chrome)
                window.location.href = "/cart";
              })
              .catch(function () {
                btn.textContent = "Fehler";
                setTimeout(function () {
                  btn.textContent = original;
                  btn.disabled = false;
                }, 1500);
              });
          });
        }
        grid.appendChild(card);
      });

      if (collHref && link) {
        link.hidden = false;
        link.setAttribute("href", collHref);
        link.textContent = collLabel
          ? collLabel.replace(/\s*→\s*$/, "") + " →"
          : "Alles Zubehör →";
      } else if (collHref && note) {
        note.hidden = false;
        note.innerHTML =
          "Weitere Optionen in der Kategorie " +
          '<a href="' +
          collHref +
          '">' +
          escapeHtml(collLabel || "Pods") +
          "</a>.";
      }
      host.hidden = false;
    });
  }

  function boot() {
    qsa(".lyd-hv2").forEach(init);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
  document.addEventListener("shopify:section:load", boot);
})();
